import './BeaconDateInputWithSubmit.scss';
import React, {useRef, useState} from 'react';
import {
    yyyymmdd,
    isBetweenFromAndToDates,
    useDebounce,
    convertToMMDDYYYY
} from 'services/Dates';
import { isEmpty } from 'lodash';
import {
    AAMBeaconButton,
    AAMBeaconControl,
    AAMBeaconError
} from 'components/shared/Beacon';
import { handleDateFormSubmit } from "../Input/DateFormValidation";

const BeaconDateInputWithSubmit = ({
                             minDate,
                             maxDate,
                             beaconTheme = 'beacon-on-light',
                             defaultDate = '',
                             onChange,
                             onClear = () => {},
                             onSubmit = () => {},
                             updateDateAlways = false,
                             inputFiledClassName,
                             id
                         }) => {
    const [date, setDate] = useState(defaultDate);
    const formRef = useRef(null);
    const [showInvalidDateMessage, setShowInvalidDateMessage] = useState(false);

    useDebounce(() => {
        if (isEmpty(date)) {
            onClear();
            return;
        }

        if (isBetweenFromAndToDates(date, minDate, maxDate) || updateDateAlways) {
            onChange(date);
        }
    }, [date]);

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (formRef.current) {
            handleDateFormSubmit(formRef.current, (showInvalid) => {
                setShowInvalidDateMessage(showInvalid);
                if (!showInvalid && formRef.current.checkValidity()) {
                    onSubmit();
                }
            });
        }
    }

    return (
        <form onSubmit={handleFormSubmit} noValidate ref={formRef}>
            <div className={'date-picker-with-submit-container ' + beaconTheme}>
                <AAMBeaconControl >
                    <input
                        type="date"
                        id={id}
                        style={inputFiledClassName}
                        min={yyyymmdd(minDate)}
                        max={yyyymmdd(maxDate)}
                        name='selectedDate'
                        required={true}
                        value={date === null ? defaultDate : date}
                        onChange={(e) => {
                            setDate(e.target.value || '')
                        }} />
                </AAMBeaconControl>
                <AAMBeaconButton
                    id='go-cta'
                    type='submit'
                    variant="primary"
                    scale="normal"
                >
                    Go
                </AAMBeaconButton>
            </div>
            {showInvalidDateMessage && (
                <AAMBeaconError id="date-beacon-error">
                    {`Please select a date between ${convertToMMDDYYYY(minDate)} and ${convertToMMDDYYYY(maxDate)}`}
                </AAMBeaconError>
            )}
        </form>
    );
};

export default BeaconDateInputWithSubmit;
